export const camsSliderSettings = {
  autoplay: false,
  draggable: true,
  responsive: [
    {
      breakpoint: 540,
      settings: { slidesToShow: 2, slidesToScroll: 2 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    },
  ],
};

export default camsSliderSettings;
